import { Alert, Button, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import type { UUID } from "../../../utils/uuid";
import type { EditableCustomDashboardConfig } from "../../luzmo/custom-dashboard-config";
import { useAccountCustomDashboards } from "../hooks/use-account-custom-dashboards";
import { AccountCustomDashboardSettings } from "./account-custom-dashboard-settings";

export const AccountCustomDashboardSection: FC<{
  accountId: UUID;
}> = ({ accountId }) => {
  const [adding, setAdding] = useState(false);
  const { dashboards, loading, error, save, remove } = useAccountCustomDashboards(accountId);

  const saveDashboard = async (config: EditableCustomDashboardConfig): Promise<void> => {
    if (await save(config)) setAdding(false);
  };

  return (
    <Paper id="custom-luzmo-dashboard" elevation={24} sx={{ p: 4 }}>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Custom Luzmo Dashboards</Typography>
          <Button
            variant="outlined"
            onClick={() => setAdding(true)}
            disabled={adding}
            data-analytics-id="ce-admin-add-custom-luzmo-dashboard"
          >
            Add dashboard
          </Button>
        </Stack>
        {loading && <LinearProgress />}
        {error && <Alert severity="error">Could not load custom dashboard settings</Alert>}
        {dashboards.map((dashboard) => (
          <AccountCustomDashboardSettings
            key={dashboard.id}
            initialValue={dashboard}
            onSave={saveDashboard}
            onDelete={() => remove(dashboard.id)}
          />
        ))}
        {adding && (
          <AccountCustomDashboardSettings
            initialValue={{ id: null, enabled: false, url: "", tabName: "" }}
            onSave={saveDashboard}
          />
        )}
      </Stack>
    </Paper>
  );
};
